const removeSlickButtonsFromTabOrder = () =>
    document.querySelectorAll('.slick-dots button').forEach(element => element.tabIndex = -1);

export default removeSlickButtonsFromTabOrder;